<template>
  <div>
    <div class="info_box">
      <div class='vxreset'>
        <i class="account_icon"></i>
        <input type='text' placeholder='请输入账号/手机号' :class="'log-input' + (account==''?' log-input-empty':'')" name='account' v-model='account'>
      </div>
      <div class='vxreset last'>
        <i class="pwd_icon"></i>
        <input type='password' placeholder='请输入密码' :class="'log-input' + (password==''?' log-input-empty':'')" v-model='password' @keyup.enter="login">
      </div>
      <div class="info_tip" :class="{'hidden-footer': hiddenFooter}">
        <span v-if="tipInfo !==''"></span>
        <p>{{tipInfo}}</p>
      </div>
    </div>

    <div class='btn_box' :class="{'hidden-footer': hiddenFooter}">
      <span class='confirm' @click="login()">登 录</span>
    </div>
    <div class="other_box" v-if="!hiddenFooter">
      <span @click="forgetShow()">忘记密码？</span>
      <p>没有账号？请<span @click="regShow()"> 注册</span></p>
    </div>
  </div>
</template>

<script>
/**
 * @description Copy from /src/components/common/Login
 */
import md5 from 'js-md5'

export default {
  name: 'LoginDQForm',
  data () {
    return {
      account: '',
      password: '',
      tipInfo: '',
      click: true,
      formData: {}
    }
  },
  props: {
    hiddenFooter: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    regShow () {
      this.$store.dispatch('change_reg_show', true)
      this.resetField()
    },
    forgetShow () {
      this.$store.dispatch('change_forget_show', true)
      this.resetField()
    },
    resetField () {
      this.account = ''
      this.password = ''
      this.tipInfo = ''
      this.click = true
      this.formData = {}
    },
    login () {
      var uPattern = /^[a-zA-Z0-9_-]{6,20}$/
      if (this.account === '') {
        this.tipInfo = '请输入账号'
      } else if (!uPattern.test(this.account)) {
        this.tipInfo = '游戏账号不正确，请重新输入'
        this.account = ''
      } else if (uPattern.test(this.account) && this.password === '') {
        this.tipInfo = '请输入密码'
      } else {
        this.tipInfo = ''
        this.toLogin()
      }
    },
    toLogin () {
      let passwordMd5 = md5(this.password)
      if (this.click) {
        this.click = false
        this.$emit('loading', true)
        this.formData['account'] = this.account
        this.formData['pwd'] = passwordMd5
        this.formData['type'] = 'pc'
        this.formData['login_type'] = 'account'
        this.axios.post('/api/interface/login', this.formData).then(res => {
          if (res) {
            this.$emit('loading', false)
            if (res.data.state === 0) {
              this.$store.commit('SET_BASEINFO', {account: this.account, password: passwordMd5, token: res.data.token, id: res.data.uid, is_first: res.data.is_first, is_bind: res.data.is_bind})
              this.setCookie(res.data.token, 30)
              setTimeout(() => {
                window.location.reload()
              })
            } else {
              this.password = ''
              this.tipInfo = res.data.msg
            }
            this.click = true
          }
        })
      }
    },
    // 设置cookie
    setCookie (token, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie = 'Access-Token' + '=' + token + ';path=/;expires=' + exdate.toGMTString()
    }
  }
}
</script>

<style lang="less" scoped  rel="stylesheet/less">
.vip_icon{
  margin: 20px auto;
  text-align: center;
  img{
    width: 182px;
    height: 59px;
  }
}
.info_box{
  padding: 0 25px;
  .last{
    padding-bottom: 0!important;
  }
  .vxreset {
    padding-bottom: 17px;
    text-align: center;
    clear: both;
    height: 48px;
    position: relative;
    i{
      display: block;
      width: 18px;
      position: absolute;
      left: 11px;
    }
    .account_icon{
      top:14px;
      height: 18px;
      background: url("../../../static/img/common/account_icon.png")no-repeat;
    }
    .pwd_icon{
      top:12px;
      height: 22px;
      background: url("../../../static/img/common/pwd_icon.png")no-repeat;
    }
    input {
      background-color: #fff;
      border: 1px solid #c5c5c5;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #1f2d3d;
      height: 48px;
      padding: 3px 10px 3px 40px;
      -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      float: left;
      width: 100%;
      font-size: 16px;
      border-radius: 5px;
      &:focus {
        border-color: #d1434a;
      }
    }
  }
  .info_tip{
    position: relative;
    padding: 10px 10px 10px 20px;
    height: 15px;
    &.hidden-footer {
      height: 21px;
    }
    span{
      display: block;
      width: 14px;
      height: 14px;
      background: url("../../../static/img/user_center/default_icon.png")no-repeat;
      position: absolute;
      left: 1px;
    }
    p{
      font-size: 12px;
      line-height: 14px;
      color: #d1434a;
      text-align: left;
    }
  }
}
.btn_box{
  width: 100%;
  height: 60px;
  .confirm{
    cursor: pointer;
    display: block;
    width: 355px;
    margin: 0 auto;
    height: 100%;
    line-height: 60px;
    color: #fff;
    background: url("../../../static/img/common/btn_bg.png")no-repeat;
  }
  &.hidden-footer {
    padding-bottom: 58px;
  }
}
.other_box{
  display: table;
  padding-bottom:30px;
  text-align: center;
  width: 100%;
  font-size: 18px;
  color: #4f4f4f;;
  letter-spacing: 1px;
  margin-top: 43px;
  span{
    cursor: pointer;
    &:hover{
      color: #d1434a;
    }
  }
  p{
    padding: 0 43px;
    margin-top: 16px;
    span{
      color: #d1434a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/AccountLoginForm.vue